<template>
  <div class="page_bg">
    <!-- 顶部 card-->
    <div class="bg_top_linear-gradient">
      <!-- 顶部返回 -->
      <div class="back_top_name flex-r-s-c">
        <van-icon name="arrow-left" @click="backPath" />
        <div class="top_name flex-c-s-s" style="margin-left:0.5rem">
          <div class="order_del_status">{{ ['待处理','已通过','已拒绝','已完成','待入库','已入库'][orderInfo.status] }}</div>
          <div class="order_del_tip" style="font-size: 0.32rem;">
            退款原因：{{ orderInfo.refundWhy }}
          </div>
        </div>
        <div class="top_icon" />
      </div>
      <!--  -->
      <div class="order_address_box " style="top: 1.68rem;min-height: 2.2rem;position: initial;">
        <template v-if="orderInfo.status === 0">
          <!-- 4步 -->
          <div v-if="orderInfo.refundType === 'RETURN_PRODUCT'" class="return_step ">
            <van-row>
              <van-col span="1" />
              <van-col span="5">
                <div class="step_step flex-r-c-c">
                  <div style="width:30%" />
                  <van-icon :name="step >= 1?'checked':'more-o'" size="0.56rem"
                            :color="step >= 1?'#0767AB':'#DADADA'"
                  />
                  <div :class="step >= 1?'blank':'blank-o'" />
                </div>
                <div class="step_msg flex-c-s-s">
                  <div style="width:30%" />
                  <div>
                    <div class="step_title">{{ orderInfo.progress[0].progressName }}</div>
                    <div class="step_time">{{ orderInfo.progress[0].createTime }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="6">
                <div class="step_step flex-r-c-c">
                  <div :class="step >= 2?'blank':'blank-o'" />
                  <van-icon :name="step >= 2?'checked':'more-o'" size="0.56rem"
                            :color="step >= 2?'#0767AB':'#DADADA'"
                  />
                  <div :class="step >= 2?'blank':'blank-o'" />
                </div>
                <div class="step_msg flex-r-c-c">
                  <div />
                  <div>
                    <div :class="step >= 2?'step_title':'step_title-o'">{{ orderInfo.progress[1].progressName }}</div>
                    <div class="step_time">{{ orderInfo.progress[1].createTime }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="6">
                <div class="step_step flex-r-c-c">
                  <div :class="step >= 3?'blank':'blank-o'" />
                  <van-icon :name="step >= 3?'checked':'more-o'" size="0.56rem"
                            :color="step >= 3?'#0767AB':'#DADADA'"
                  />
                  <div :class="step >= 3?'blank':'blank-o'" />
                </div>
                <div class="step_msg flex-r-c-c">
                  <div />
                  <div>
                    <div :class="step >= 3?'step_title':'step_title-o'">
                      {{ orderInfo.progress[2].progressName || '寄回商品' }}
                    </div>
                    <div class="step_time">{{ orderInfo.progress[2].createTime || '' }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="5">
                <div class="step_step flex-r-c-c">
                  <div :class="step >= 4?'blank':'blank-o'" />
                  <van-icon :name="step >= 4?'checked':'more-o'" size="0.56rem"
                            :color="step >= 4?'#0767AB':'#DADADA'"
                  />
                  <div style="width:30%" />
                </div>
                <div class="step_msg flex-r-c-c">
                  <div style="width:30%" />
                  <div>
                    <div :class="step >= 4?'step_title':'step_title-o'">
                      {{ orderInfo.progress[3].progressName || '退货成功' }}
                    </div>
                    <div class="step_time">{{ orderInfo.progress[3].createTime || '' }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="1" />
            </van-row>
          </div>
          <!-- 3步 -->
          <div v-else class="return_step ">
            <van-row>
              <van-col span="1" />
              <van-col span="7">
                <div class="step_step flex-r-c-c">
                  <div style="width:30%" />
                  <van-icon :name="step >= 1?'checked':'more-o'" size="0.56rem"
                            :color="step >= 1?'#0767AB':'#DADADA'"
                  />
                  <div :class="step >= 1?'blank':'blank-o'" />
                </div>
                <div class="step_msg flex-c-s-s">
                  <div style="width:30%" />
                  <div>
                    <div class="step_title">{{ orderInfo.progress[0].progressName }}</div>
                    <div class="step_time">{{ orderInfo.progress[0].createTime }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="8">
                <div class="step_step flex-r-c-c">
                  <div :class="step >= 2?'blank':'blank-o'" />
                  <van-icon :name="step >= 2?'checked':'more-o'" size="0.56rem"
                            :color="step >= 2?'#0767AB':'#DADADA'"
                  />
                  <div :class="step >= 2?'blank':'blank-o'" />
                </div>
                <div class="step_msg flex-r-c-c">
                  <div />
                  <div>
                    <div :class="step >= 2?'step_title':'step_title-o'">{{ orderInfo.progress[1].progressName }}</div>
                    <div class="step_time">{{ orderInfo.progress[1].createTime }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="7">
                <div class="step_step flex-r-c-c">
                  <div :class="step >= 3?'blank':'blank-o'" />
                  <van-icon :name="step >= 3?'checked':'more-o'" size="0.56rem"
                            :color="step >= 3?'#0767AB':'#DADADA'"
                  />
                  <div style="width:30%" />
                </div>
                <div class="step_msg flex-r-c-c">
                  <div style="width:30%" />
                  <div>
                    <div :class="step >= 3?'step_title':'step_title-o'">
                      {{ orderInfo.progress[2].progressName|| '退货成功' }}
                    </div>
                    <div class="step_time">{{ orderInfo.progress[2].createTime|| '' }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="1" />
            </van-row>
          </div>
        </template>
        <template v-else>
          <div class="return_step ">
            <van-row>
              <van-col span="1" />
              <van-col span="7">
                <div class="step_step flex-r-c-c">
                  <div style="width:30%" />
                  <van-icon :name="step >= 1?'checked':'more-o'" size="0.56rem"
                            :color="step >= 1?'#0767AB':'#DADADA'"
                  />
                  <div :class="step >= 1?'blank':'blank-o'" />
                </div>
                <div class="step_msg flex-c-s-s">
                  <div style="width:30%" />
                  <div>
                    <div class="step_title">{{ orderInfo.progress[0].progressName }}</div>
                    <div class="step_time">{{ orderInfo.progress[0].createTime }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="8">
                <div class="step_step flex-r-c-c">
                  <div :class="step >= 2?'blank':'blank-o'" />
                  <van-icon :name="step >= 2?'checked':'more-o'" size="0.56rem"
                            :color="step >= 2?'#0767AB':'#DADADA'"
                  />
                  <div :class="step >= 2?'blank':'blank-o'" />
                </div>
                <div class="step_msg flex-r-c-c">
                  <div />
                  <div>
                    <div :class="step >= 2?'step_title':'step_title-o'">{{ orderInfo.progress[1].progressName }}</div>
                    <div class="step_time">{{ orderInfo.progress[1].createTime }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="7">
                <div class="step_step flex-r-c-c">
                  <div :class="step >= 3?'blank':'blank-o'" />
                  <van-icon :name="step >= 3?'checked':'more-o'" size="0.56rem"
                            :color="step >= 3?'#0767AB':'#DADADA'"
                  />
                  <div style="width:30%" />
                </div>
                <div class="step_msg flex-r-c-c">
                  <div style="width:30%" />
                  <div>
                    <div :class="step >= 3?'step_title':'step_title-o'">
                      {{ orderInfo.progress[2].progressName|| '退货成功' }}
                    </div>
                    <div class="step_time">{{ orderInfo.progress[2].createTime|| '' }}</div>
                  </div>
                </div>
              </van-col>
              <van-col span="1" />
            </van-row>
          </div>
        </template>
        <div class="order_address_msg flex-c-s-c"
             style="text-align: left;padding-left:0.34rem;padding-top:0.34rem;padding-bottom:0.34rem;width:90%"
        >
          <div class="address_msg_name">您已成功发起退货申请，请耐心等待商家处理 </div>
          <div class="address_msg_addres van-multi-ellipsis--l2" style="margin-top:0.21rem">
            商家同意，系统将退款给您；
          </div>
          <div class="address_msg_addres van-multi-ellipsis--l2" style="margin-top:0.05rem">
            如果商家拒绝，请联系商家客服进行处理。
          </div>
        </div>
      </div>
      <!-- 退款总额 -->
      <div class="order_check_box order_payway_box flex-r-sb-c" style="margin-top:0.23rem;padding:0.19rem 0;margin-bottom:0">
        <div class="check_title" style="line-height: 1rem;padding-top:0">退款总额</div>
        <div class="check_money" style="line-height: 1rem;font-size: 0.4rem;color: #ED0D0D;padding-right:0.5rem">
          ￥{{ orderInfo.refundAmount }}</div>
      </div>
      <!-- 商品区域 -->
      <div class="order_pro_box" style="margin-top:0.23rem">
        <div class="cart_company" style="margin-bottom:0;margin-top:0">
          <div class="company_name flex-r-s-c">
            退款商品
          </div>
          <div class="company_pro_list">
            <div v-for="(pro_item,pro_index) in orderInfo.detailProductRes" :key="pro_index" class="flex-r-s-c">
              <van-swipe-cell>
                <proCard04 :info="pro_item" />
                <!-- 优惠信息 -->
                <!-- <div v-if="pro_item.resActicityDtos" class="pro_discount_box">
                  <div class="pro_discount_items">
                    <div v-for="(discounts,discounts_index) in pro_item.resActicityDtos" :key="discounts_index"
                         class="pro_discount_item">
                      <span class="discounts_tag">{{ discounts.actionName }}：</span>
                      <span v-for="(discount,discount_index) in discounts.actions" :key="discount_index"
                            class="discounts_tag">
                        {{ discount }}
                      </span>
                    </div>
                  </div>
                </div> -->
              </van-swipe-cell>
            </div>
          </div>
          <van-cell-group>
            <van-field v-model="orderInfo.remark" label="备注:" placeholder="" readonly label-width="1rem" />
          </van-cell-group>
        </div>
      </div>
      <!-- 退款编号 -->
      <div class="order_check_box order_payway_box flex-r-sb-c" style="margin-top:0.23rem;padding:0.19rem 0 ">
        <div class="check_title" style="line-height: 1rem;padding-top:0">退款编号</div>
        <div class="check_money" style="line-height: 1rem;font-size: 0.4rem;color: #333333;padding-right:0.5rem">
          {{ orderInfo.refundNo }}</div>
      </div>
    </div>
    <!-- 底部bar -->
    <!-- <orderDel ref="orderSub" :info="orderInfo" @action="action" /> -->
  </div>
</template>

<script>
import './index.scss'
import './../cart/index.scss'
// import orderDel from '@/components/bar/order_del'
import { refund_listDetail } from '@/api/order'
import proCard04 from '@/components/pro_card_04'
export default {
  name: 'OrderDetail',
  // components: { proCard04, orderDel },
  components: { proCard04 },
  data() {
    return {
      ischangeAddress: false,
      orderId: '',
      orderInfo: { progress: [{}, {}, {}, {}] },
      activeList: [],
      step: null,
      time: 60 * 1000 * 2880
    }
  },
  created() {
    if (window.name === '') {
      console.log('首次被加载')
      window.name = 'returnStatus' // 在首次进入页面时我们可以给window.name设置一个固定值
    } else if (window.name === 'isReload') {
      sessionStorage.setItem('jump', true)
    }
    this.orderId = this.$route.query.orderId
    this.getDetail()
  },
  methods: {
    backPath() { window.history.back() },
    getDetail() {
      // 订单信息
      refund_listDetail(this.orderId).then(res => {
        var info = res.data[0]
        const parms1 = { active: 1, createTime: '', progressName: '发起成功' }
        const parms2 = { active: 0, createTime: '', progressName: '退回商品' }
        const parms3 = { active: 0, createTime: '', progressName: '退款成功' }
        if (info.status === 0) {
          if (info.refundType === 'RETURN_PRODUCT') {
            if (info.progress.length === 2) {
              info.progress.push(parms2)
              info.progress.push(parms3)
              this.step = 2
            } else if (info.progress.length === 3) {
              if (info.progress.progressName === '退款驳回') {
                info.progress.push(parms3)
                this.step = 3
              } else {
                info.progress.push(parms3)
                this.step = 3
              }
            }
          } else {
            if (info.progress.length === 2) {
              info.progress.push(parms3)
              this.step = 2
            } else if (info.progress.length === 1) {
              info.progress.unshift(parms1)
              info.progress.push(parms3)
              this.step = 2
              console.log('info', info)
            }
          }
        } else { this.step = 3 }
        this.orderInfo = info
        console.log('this.orderInfo', this.orderInfo)
      })
    },
    // 底部行为
    action(e) {
      console.log(e)
      if (e === 'pay') { this.$router.push('/order/payResult?status=4') }
      if (e === 'address') { this.ischangeAddress = !this.ischangeAddress }
    },
    // 修改地址
    changeAddress(addressId) {
      this.$router.push('/user/addressList?aId=' + addressId)
    }
  }
}
</script>

<style>
.van-count-down {
  color: #fff;
}
body {
  background: #f7f7f7;
}
</style>
